import { MultiCombobox } from 'src/shared/entities/control-entities/multicombobox.entity';
import type { Directories } from 'src/store/directories/directories.store';

import type { TMultiComboboxRaw, TSavedFormValue } from '../../types';

type TMulticomboboxSerializerOptions = {
  item: TMultiComboboxRaw;
  directories: Directories;
  savedValue?: TSavedFormValue;
};

const isValidInitialValue = (value: unknown): value is number[] => {
  return (
    Array.isArray(value) && (value.every((v) => typeof v === 'number') || value.every((v) => typeof v === 'string'))
  );
};

export const mapMulticombobox = ({ item, directories, savedValue }: TMulticomboboxSerializerOptions): MultiCombobox => {
  const data = {
    directories,
    formElementRefId: item.attrName,
    fieldId: item.fieldId,
    useInMainProgressBar: !!item.useInMainProgressBar,
    required: !!item.required,
    enableIf: item.enableIf,
    visuallyDisabled: item.visuallyDisabled,
    calculatedValue: item.calculatedValue,
    updateDictValue: item.updateDictValue,
    computeTags: item.computeTags,
    additionalConditionalAttributes: item.additionalConditionalAttributes,
    checkDictValue: item.checkDictValue,
    refObjectAttr: item.refObjectAttr,
    refObjectType: item.refObjectType,
    onChangeInstructions: item.onChange,
    refObjectFilterByFields: item.refObjectFilterByFields,
    restrictions: { required: !!item.required },
    directory: directories.getObject(item.refObjectType),
    refQuery: 'refQuery' in item ? item.refQuery : undefined,
    label: directories.getFieldLabel(item.fieldId) || undefined,
    placeholder: directories.getFieldPlaceholder(item.fieldId) || undefined,
    initialValue: isValidInitialValue(savedValue) ? savedValue : undefined,
    settings: item.settings,
  };

  return new MultiCombobox(data);
};
